import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorize-user',
  templateUrl: './authorize-user.component.html',
  styleUrls: ['./authorize-user.component.css']
})
export class AuthorizeUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.log("ccccc....");
  }

}
